import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-beige font-sans text-brown-dark selection:bg-gold selection:text-brown-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Solution data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Urgency data-id="element-6" />
      <Offer data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}